// Large record button with recording states

interface RecordButtonProps {
  isRecording: boolean
  onStart: () => void
  onStop: () => void
  disabled?: boolean
}

export default function RecordButton({
  isRecording,
  onStart,
  onStop,
  disabled = false,
}: RecordButtonProps) {
  const handleClick = () => {
    if (disabled) return
    if (isRecording) {
      onStop()
    } else {
      onStart()
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      aria-label={isRecording ? 'Stop recording' : 'Start recording'}
      className={`
        w-20 h-20 rounded-full
        flex items-center justify-center
        transition-all duration-200
        focus:outline-none focus:ring-4 focus:ring-red-500/50
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:scale-95'}
        ${isRecording
          ? 'bg-red-600 animate-pulse-record'
          : 'bg-red-500 hover:bg-red-600'
        }
      `}
    >
      {isRecording ? (
        // Stop icon (square)
        <div className="w-6 h-6 bg-white rounded-sm" />
      ) : (
        // Record icon (circle)
        <div className="w-12 h-12 bg-white rounded-full" />
      )}
    </button>
  )
}
